<template>
  <div>
    <!-- blog Section Start -->
    <section
      id="blog"
      class="blog"
    >
      <div class="about-decor">
        <div class="about-circle1">
          <img
            src="../assets/images/team1.png"
            alt=""
          >
        </div>
        <div class="about-circle2">
          <img
            src="../assets/images/main-banner1.png"
            alt=""
          >
        </div>
      </div>
      <div class="container">
        <div class="row">
          <div class="col-sm-12">
            <h2 class="title">
              latest <span>blog</span>
            </h2>
          </div>
          <div class="col-sm-12">
            <carousel
              class-name="blog-carousel"
              :loop="true"
              :margin="30"
              :items="2"
              :center="false"
              :nav="false"
              :dots="true"
              :autoplay="true"
              :responsive="{0:{items:1,nav:false},600:{items:1,nav:false},768:{items:2,nav:false},992:{items:2,nav:false},1000:{items:2,nav:false}}"
            >
              <div class="blog-item">
                <div class="blog-block">
                  <div class="blog-box">
                    <div class="overflow-hidden">
                      <a href="blog-details"><img
                        src="../assets/images/blog/blog1.jpg"
                        class="img-fluid"
                        alt=""
                      ></a>
                    </div>
                  </div>
                </div>
                <div class="blog-text">
                  <h6>12 November 2019</h6>
                  <a href="blog-details">
                    <h3>See How MechaniClick Saves You Money</h3>
                  </a>
                  <h5>posted by Mark jkcno, 10 hits, 50 comment</h5>
                </div>
              </div>
              <div class="blog-item">
                <div class="blog-block">
                  <div class="blog-box">
                    <div class="overflow-hidden">
                      <a href="blog-details"><img
                        src="../assets/images/blog/blog2.jpg"
                        class="img-fluid"
                        alt=""
                      ></a>
                    </div>
                  </div>
                </div>
                <div class="blog-text">
                  <h6>25 October 2019</h6>
                  <a href="/blog-details2">
                    <h3>How To Pay For Car Repairs If You Don’t Have An Emergency Fund?</h3>
                  </a>
                  <h5>posted by Andrew Simons, 1 hits, 5 comment</h5>
                </div>
              </div>
              <div class="blog-item">
                <div class="blog-block">
                  <div class="blog-box">
                    <div class="overflow-hidden">
                      <a href="blog-details2"><img
                        src="../assets/images/blog/blog6.jpg"
                        class="img-fluid"
                        alt=""
                      ></a>
                    </div>
                  </div>
                </div>
                <div class="blog-text">
                  <h6>15 September 2019</h6>
                  <a href="blog-details2">
                    <h3>How to Pay for Car Repairs If You Don’t Have an Emergency Fund?</h3>
                  </a>
                  <h5>posted by johanson let, 15 hits, 30 comment</h5>
                </div>
              </div>
              <div class="blog-item">
                <div class="blog-block">
                  <div class="blog-box">
                    <div class="overflow-hidden">
                      <a href="blog-details"><img
                        src="../assets/images/blog/blog7.jpg"
                        class="img-fluid"
                        alt=""
                      ></a>
                    </div>
                  </div>
                </div>
                <div class="blog-text">
                  <h6>10 October 2019</h6>
                  <a href="blog-details">
                    <h3>DON’T DELAY YOUR COLLISION REPAIR WORK</h3>
                  </a>
                  <h5>posted by John Shipmen, 6 hits, 8 comment</h5>
                </div>
              </div>
              <div class="blog-item">
                <div class="blog-block">
                  <div class="blog-box">
                    <div class="overflow-hidden">
                      <a href="blog-details3"><img
                        src="../assets/images/blog/blog8.jpg"
                        class="img-fluid"
                        alt=""
                      ></a>
                    </div>
                  </div>
                </div>
                <div class="blog-text">
                  <h6>28 September 2019</h6>
                  <a href="blog-details3">
                    <h3>New study shows importance of good tires</h3>
                  </a>
                  <h5>posted by Walo Boni, 9 hits, 4 comment</h5>
                </div>
              </div>
            </carousel>
          </div>
        </div>
      </div>
    </section>
    <!-- blog Section End -->
  </div>
</template>
<script>
import carousel from 'v-owl-carousel'

export default {
  name: 'LatestBlog',
  components: { carousel },
}
</script>



// WEBPACK FOOTER //
// src/components/latest_blog.vue